// extracted by mini-css-extract-plugin
export default {"heading":"Jo-z","createAccount":"Ko-z","disabled":"Lo-z","copy":"Mo-z","terms":"No-z"};